import StripePayment from 'utils/stripe_payment';

window.initStripe = function(args) {
  window.stripePayment = new StripePayment(args);
  window.stripePayment.setup();
}
